import * as yup from 'yup';
import { ProvinceCreateModel, ProvinceUpdateModel } from './destination.model';

export const destinationCreateSchema: yup.ObjectSchema<ProvinceCreateModel> = yup.object({
  title_la: yup.string().required('ກະລຸນາປ້ອນຊື່ (LA)'),
  title_en: yup.string().required('ກະລຸນາປ້ອນຊື່ (EN)'),
  description: yup.string().required('ກະລຸນາປ້ອນຄໍາອະທິບາຍ'),
});

export const destinationUpdateSchema: yup.ObjectSchema<ProvinceUpdateModel> = yup.object({
  id: yup.string(),
  uuid: yup.string(),
  title_la: yup.string().required('ກະລຸນາປ້ອນຊື່ (LA)'),
  title_en: yup.string().required('ກະລຸນາປ້ອນຊື່ (EN)'),
  description: yup.string().required('ກະລຸນາປ້ອນຄໍາອະທິບາຍ'),
});
